export default "images/红绿灯提示-绿灯.png";